import React from "react"
import SignUpEmployeeAlreadyRegisteredPage from "../components/signup-employee-already-registered"

export default function SignUpEmployeeAlreadyRegistered() {
  return <SignUpEmployeeAlreadyRegisteredPage />
}
